import type { EvolutionAttachedPrintable } from './evolutionWorkflowTypes';

/**
 * Itens somente em `procedureLabels` (fluxo cadastro geral, sem anexo `indication`)
 * não aparecem em `attachedPrintables`. Para «Imprimir todos», gera um bloco único.
 */
export function buildEvolutionPrintBatch(
  attachedPrintables: EvolutionAttachedPrintable[],
  procedureLabels: string[],
): EvolutionAttachedPrintable[] {
  const items = [...attachedPrintables];
  const hasIndicationAttachment = attachedPrintables.some((p) => p.category === 'indication');
  const trimmed = procedureLabels.map((l) => String(l || '').trim()).filter(Boolean);
  if (trimmed.length > 0 && !hasIndicationAttachment) {
    items.push({
      clientKey: `evolution-batch-indication-labels:${crypto.randomUUID()}`,
      category: 'indication',
      templateName: 'Indicações',
      bodyText: ['INDICAÇÕES', '', ...trimmed.map((l) => `• ${l}`)].join('\n'),
    });
  }
  return items;
}

export function evolutionHasPrintBatchContent(
  attachedPrintables: EvolutionAttachedPrintable[],
  procedureLabels: string[],
): boolean {
  if (attachedPrintables.length > 0) return true;
  return procedureLabels.some((l) => String(l || '').trim().length > 0);
}
